import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';

import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { Utils } from '@src/utils/util';
import { DeployedPackagesComponent } from '@app/authorized/environmentDetails/deployed-packages/deployed-packages.component';
import { DeployedPackagesFilterComponent } from '@app/authorized/environmentDetails/deployed-packages/deployed-packages-filter/deployed-packages-filter.component';
import { DeployedPackagesDataComponent } from '@app/authorized/environmentDetails/deployed-packages/deployed-packages-data/deployed-packages-data.component';

@NgModule({
    imports: [SharedModule, MatTableModule, MatSortModule, MatDatepickerModule, MatInputModule, MatNativeDateModule],
    declarations: [DeployedPackagesComponent, DeployedPackagesFilterComponent, DeployedPackagesDataComponent],
    entryComponents: [DeployedPackagesComponent],
    exports: [DeployedPackagesComponent],
    providers: [MatDatepickerModule, MatNativeDateModule, Utils]
})
export class DeployedPackagesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/deployed-packages/deployed-packages.module.ts